class ArticleMeta {
  constructor() {
    this.articleAsset = document.getElementsByClassName('js-article-meta')[0].id;
    this.init();
  }

  init() {

    if (document.querySelectorAll('meta[name="twitter:image"]').length > 0) {
      return;
    } else {
      const link = document.createElement('meta');
      link.setAttribute('name', 'twitter:image');
      link.content = this.articleAsset;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }
}

export default ArticleMeta;
